// extracted by mini-css-extract-plugin
export default {"cardWrapper":"cardEmployee_cardWrapper__K-ezn","decorV":"cardEmployee_decorV__rPx5T","photoWrapper":"cardEmployee_photoWrapper__hE2bH","photo":"cardEmployee_photo__X0H+3"};